import React from "react";
import { Col, Row } from "react-bootstrap";
import { FormControl, TextField } from "@material-ui/core";
import { TIPOS_SOCIETARIOS } from "../../utils/tiposSocietarios";

const defaultFieldLabel = {
	display: "block",
	fontSize: 13,
	fontWeight: 600,
	color: "#122150",
	marginBottom: 6,
};

const SITUACOES_CADASTRAIS = [
	{ value: "nula", label: "Nula" },
	{ value: "ativa", label: "Ativa" },
	{ value: "suspensa", label: "Suspensa" },
	{ value: "inapta", label: "Inapta" },
	{ value: "baixada", label: "Baixada" },
];

export default function EmpresaCnaeNaturezaFields({
	values,
	handleChange,
	handleBlur,
	fieldLabel = defaultFieldLabel,
	showSituacao = true,
	showTipoSocietario = true,
	showHint = true,
}) {
	return (
		<>
			{showHint ? (
				<p className="meu-perfil__secao-hint" style={{ margin: "0 4px 12px" }}>
					Campos pendentes de gravação — aguarda criação na(s) tabela(s) / API (LV).
				</p>
			) : null}
			<Row>
				{showSituacao ? (
					<Col xs={12} md={6} className="px-2 pb-3">
						<label style={fieldLabel}>Situação Cadastral</label>
						<FormControl fullWidth>
							<TextField
								select
								variant="outlined"
								name="emp_situacao_cadastral"
								value={values.emp_situacao_cadastral || ""}
								onBlur={handleBlur}
								onChange={handleChange}
								SelectProps={{ native: true }}
								inputProps={{ translate: "no" }}
							>
								<option value="">Selecionar...</option>
								{SITUACOES_CADASTRAIS.map((opt) => (
									<option key={opt.value} value={opt.value}>
										{opt.label}
									</option>
								))}
							</TextField>
						</FormControl>
					</Col>
				) : null}
				<Col xs={12} md={6} className="px-2 pb-3">
					<label style={fieldLabel}>Código da Natureza Jurídica</label>
					<FormControl fullWidth>
						<TextField
							variant="outlined"
							name="emp_natureza_juridica_codigo"
							placeholder="Ex: 206-2"
							value={values.emp_natureza_juridica_codigo || ""}
							onBlur={handleBlur}
							onChange={handleChange}
							inputProps={{ translate: "no" }}
						/>
					</FormControl>
				</Col>
				<Col xs={12} md={showTipoSocietario ? 8 : 12} className="px-2 pb-3">
					<label style={fieldLabel}>Natureza Jurídica Oficial</label>
					<FormControl fullWidth>
						<TextField
							variant="outlined"
							name="emp_natureza_juridica_descricao"
							placeholder="Ex: Sociedade Empresária Limitada"
							value={values.emp_natureza_juridica_descricao || ""}
							onBlur={handleBlur}
							onChange={handleChange}
							inputProps={{ translate: "no" }}
						/>
					</FormControl>
				</Col>
				{showTipoSocietario ? (
					<Col xs={12} md={4} className="px-2 pb-3">
						<label style={fieldLabel}>Tipo de Empresa</label>
						<FormControl fullWidth>
							<TextField
								select
								variant="outlined"
								name="emp_tipo_societario"
								value={values.emp_tipo_societario || ""}
								onBlur={handleBlur}
								onChange={handleChange}
								SelectProps={{ native: true }}
								inputProps={{ translate: "no" }}
							>
								<option value="">Selecionar...</option>
								{TIPOS_SOCIETARIOS.map((opt) => (
									<option key={opt.value} value={opt.value}>
										{opt.label}
									</option>
								))}
							</TextField>
						</FormControl>
					</Col>
				) : null}
				<Col xs={12} md={3} className="px-2 pb-3">
					<label style={fieldLabel}>CNAE Principal — Código</label>
					<FormControl fullWidth>
						<TextField
							variant="outlined"
							name="emp_cnae_principal_codigo"
							placeholder="Ex: 1979-0/00"
							value={values.emp_cnae_principal_codigo || ""}
							onBlur={handleBlur}
							onChange={handleChange}
							inputProps={{ translate: "no" }}
						/>
					</FormControl>
				</Col>
				<Col xs={12} md={9} className="px-2 pb-3">
					<label style={fieldLabel}>CNAE Principal — Descrição</label>
					<FormControl fullWidth>
						<TextField
							variant="outlined"
							name="emp_cnae_principal_descricao"
							placeholder="Descrição do CNAE principal"
							value={values.emp_cnae_principal_descricao || ""}
							onBlur={handleBlur}
							onChange={handleChange}
							inputProps={{ translate: "no" }}
						/>
					</FormControl>
				</Col>
				<Col xs={12} className="px-2 pb-3">
					<label style={fieldLabel}>CNAEs Secundários</label>
					<FormControl fullWidth>
						<TextField
							variant="outlined"
							name="emp_cnaes_secundarios"
							placeholder="0000-0/00, 0000-0/00"
							value={values.emp_cnaes_secundarios || ""}
							onBlur={handleBlur}
							onChange={handleChange}
							inputProps={{ translate: "no" }}
						/>
					</FormControl>
				</Col>
			</Row>
		</>
	);
}

export const EMPRESA_CNAE_NATUREZA_INITIAL = {
	emp_situacao_cadastral: "",
	emp_natureza_juridica_codigo: "",
	emp_natureza_juridica_descricao: "",
	emp_tipo_societario: "",
	emp_cnae_principal_codigo: "",
	emp_cnae_principal_descricao: "",
	emp_cnaes_secundarios: "",
};

export const EMPRESA_CNAE_NATUREZA_STRIP_KEYS = [
	"emp_situacao_cadastral",
	"emp_natureza_juridica_codigo",
	"emp_natureza_juridica_descricao",
	"emp_tipo_societario",
	"emp_cnae_principal_codigo",
	"emp_cnae_principal_descricao",
	"emp_cnaes_secundarios",
];
